import React from 'react'
import { useTranslation } from 'react-i18next'

import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'

export type PaymentProps = {
  isActivated?: boolean
  isConfiguring?: boolean
  isDeleting?: boolean
  isUpdatingShowPayment?: boolean
  onConfigurePayment?: () => void
  onShowPaymentChange?: (isShown: boolean) => void
  onDeletePaymentAccount?: () => void
  showPayment?: boolean
  checkStripe?: () => void
}

export function Payment(props: PaymentProps) {
  const {
    isActivated = false,
    isConfiguring = false,
    isDeleting = false,
    isUpdatingShowPayment = false,
    onConfigurePayment,
    onShowPaymentChange,
    onDeletePaymentAccount,
    checkStripe,
    showPayment = false,
  } = props
  const { t } = useTranslation()

  const handleShowPaymentChange = () => {
    onShowPaymentChange?.(!showPayment)
  }

  return (
    <Stack direction="column" gap="10px">
      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap="10px">
        {!isActivated && <Button onClick={checkStripe} variant="outlined">
          {t('page.configuration.payment.checkStripeAccountButton.label')}
        </Button>}
        <LoadingButton color="primary" disableElevation loading={isConfiguring} onClick={onConfigurePayment} variant="contained">
          {t('page.configuration.payment.configurePaymentButton.label')}
        </LoadingButton>
        {isActivated && (
          <LoadingButton color="warning" disableElevation loading={isDeleting} onClick={onDeletePaymentAccount} variant="outlined">
            {t('page.configuration.payment.deleteStripeAccountButton.label')}
          </LoadingButton>
        )}
      </Stack>
      {isActivated && (
        <Stack direction="row" justifyContent="flex-end" alignItems="center" gap="10px">
          <Typography fontWeight="500">{t('page.configuration.payment.showPayment.label')}</Typography>
          <Switch disabled={isUpdatingShowPayment} checked={showPayment} onChange={handleShowPaymentChange} />
        </Stack>
      )}
    </Stack>
  )
}

export default Payment
